<template>
  <section v-if="targetProject" class="Project_Container">
    <ProjectPageHeader
      :title="targetProject.title"
      :headerImage="targetProject.headerImage"
    />

    <ProjectPageInnerNav
      ref="innerNav"
      :targetProject="targetProject"
      :scrollToSectionWithId="scrollToSectionWithId"
    />
    <span ref="about" />
    <ProjectPageAbout
      :title="sectionTitles.about"
      :data="targetProject.aboutProgram"
      :img="targetProject.img"
    />
    <span ref="advantages" />
    <ProjectPageAdvantages
      v-if="
        targetProject.spacificationList &&
        targetProject.spacificationList.length > 0
      "
      :title="sectionTitles.spacification"
      :data="targetProject.spacificationList"
    />
    <span ref="descriptionVideo" />
    <ProjectPageVideoContainer
      v-if="targetProject.descriptionVideoLink"
      :title="sectionTitles.description"
      :videoSrc="targetProject.descriptionVideoLink"
    />

    <span ref="pricing" />
    <ProjectPagePricing
      v-if="targetProject.pricingList"
      :title="sectionTitles.pricing"
      :data="targetProject.pricingList"
      :projectName="targetProject.title"
      :designYourNeeds="targetProject.designYourNeeds"
    />
    <span ref="designYourNeeds" />
    <ProjectPageDesignNeeds
      v-if="targetProject.designYourNeeds"
      :title="sectionTitles.designYourNeeds"
      :designYourNeeds="targetProject.designYourNeeds"
      :programName="targetProject.title"
    />
    <span ref="OrderTacker" />
    <OrderTacker
      v-if="targetProject.orderTacker"
      :title="targetProject.orderTacker.title"
      :description="targetProject.orderTacker.description"
      :spacifications="targetProject.orderTacker.spacifications"
      :img="targetProject.orderTacker.img"
    />

    <section
      :class="{
        wave_container: true,
        gray: (linksNum + (targetProject.orderTacker ? 1 : 0)) % 2 != 0,
      }"
    >
      <WaveFooter />
    </section>
  </section>
</template>

<script>
import WaveFooter from "@/components/WavFooter";
import ProjectPageHeader from "@/components/ProjectPage/ProjectPageHeader";
import ProjectPageInnerNav from "@/components/ProjectPage/ProjectPageInnerNav";
import ProjectPageAbout from "@/components/ProjectPage/ProjectPageAbout";
import ProjectPageAdvantages from "@/components/ProjectPage/ProjectPageAdvantages";
import ProjectPageVideoContainer from "@/components/ProjectPage/ProjectPageVideoContainer";
import ProjectPagePricing from "@/components/ProjectPage/ProjectPagePricing";
import ProjectPageDesignNeeds from "@/components/ProjectPage/ProjectPageDesignNeeds";
import OrderTacker from "@/components/ProjectPage/OrderTacker";
export default {
  name: "ProjectPage",
  components: {
    ProjectPageHeader,
    ProjectPageInnerNav,
    ProjectPageAbout,
    ProjectPageAdvantages,
    ProjectPageVideoContainer,
    ProjectPagePricing,
    ProjectPageDesignNeeds,
    WaveFooter,
    OrderTacker,
  },
  data() {
    return {
      linksNum: 0,
    };
  },
  mounted() {
    this.$watch(
      () => {
        return this.$refs["innerNav"]?.getActiveLinks();
      },
      () => {
        this.updateLinksNum();
      },
      {
        immediate: true,
      }
    );
  },
  methods: {
    scrollToSectionWithId(targetId) {
      if (this.$refs[targetId]) {
        const innerHavHeight =
          this.$refs["innerNav"]?.$refs["main"]?.offsetHeight || 0;
        window.scrollTo({
          top: this.$refs[targetId].offsetTop - innerHavHeight,
          behavior: `smooth`,
        });
      }
    },
    updateLinksNum() {
      const num = this.$refs["innerNav"]?.getActiveLinks();
      num != this.linksNum && (this.linksNum = num);
    },
    checkProjectId() {
      if (!this.targetProject) {
        // invalid Id , Redirect To Home Page
        this.$router.push("/NotFound");
      }
    },
  },
  computed: {
    targetProject() {
      const { lang } = this.$store.state;
      return this.$store.state[lang].projects.data.filter((project) => {
        return project.id == this.id;
      })[0];
    },
    sectionTitles() {
      const { lang } = this.$store.state;
      return this.$store.state[lang].projects.sectionsTitles;
    },
  },
  props: ["id"],
  watch: {
    id: {
      handler: "checkProjectId",
      immediate: true,
    },
  },
};
</script>
